import Keycloak from 'keycloak-js';

const initKeycloak = async (keycloakConfig) => {
  const keycloak = new Keycloak(keycloakConfig);
  await keycloak.init({
    checkLoginIframe: false,
    onLoad: "login-required"
  });
  return keycloak;
};

export { initKeycloak };
